/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FieldRecordCounts } from "./FieldRecordCounts";
export const RecordCounts = core.serialization.object({
    total: core.serialization.number(),
    valid: core.serialization.number(),
    error: core.serialization.number(),
    errorsByField: core.serialization.record(core.serialization.string(), core.serialization.number()).optional(),
    byField: core.serialization.record(core.serialization.string(), FieldRecordCounts).optional(),
});
